import React from "react";
import { ToastContainer } from "react-toastify";

import SettingsAssetsDetails from "./components/SettingsAssetsDetails";

const SettingsAssetsDetailsApp = (props) => {
  return (
    <>
      <ToastContainer icon={false} />
      <SettingsAssetsDetails {...props} />
    </>
  );
};

export default SettingsAssetsDetailsApp;
